import { background } from "../../resources/js/images";
import Hero from "../contactUs/Hero";
import HeroDetails from "./heroDetails";

const Login = () => {
    return (
        <div className="bg-blue-700 sm:bg-transparent pt-[10rem] sm:pt-0">
            <Hero
                content={<HeroDetails />}
                url={background}
                wrapperClass={"min-h-screen hidden sm:block"}
                containerClass={" mb-0 sm:mb-0 xl:mb-0 2xl:mb-0 lg:mb-0"}
            />
            <div className="sm:hidden bg-white  rounded-t-2.5">
                <HeroDetails />
            </div>
        </div>
    );
};

export default Login;
